import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import type { Observable } from 'rxjs';

import type { TOfferKind } from '@core/offers-types';

export enum ResourceKind {
  Candidate = 'candidate',
  Job = 'job',
  Requisition = 'requisition',
  TalentPool = 'talent_pool',
}

export type SnapshotResolver<T> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => Observable<T>;

export type VisitedEntityBase<T extends ResourceKind, Options extends {}> = {
  id: number;
  name: string;
  kind: T;
} & Options;

export type TalentPoolVisitedSnapshot = VisitedEntityBase<
  ResourceKind.TalentPool,
  { slug: string }
>;
export type JobVisitedSnapshot = VisitedEntityBase<
  ResourceKind.Job,
  { status: string; slug: string; statusKind: TOfferKind }
>;
export type RequisitionVisitedSnapshot = VisitedEntityBase<ResourceKind.Requisition, {}>;

export type CandidateVisitedSnapshot = VisitedEntityBase<
  ResourceKind.Candidate,
  {
    photoThumbUrl: string;
    initials: string;
    hasAvatar: boolean;
    isAnonymous?: boolean;
  }
>;

export type RecentNavigationSnapshot =
  | CandidateVisitedSnapshot
  | TalentPoolVisitedSnapshot
  | JobVisitedSnapshot
  | RequisitionVisitedSnapshot;
